<template>
  <div v-if="maxLength > defaultLength" class="collapse">
    <div class="expand-line"></div>
      <!-- <span v-if="!expanded" class="collapse-text">更多 {{maxLength - defaultLength}} 位, </span> -->
      <div @click="collapse" class="collapse-action">{{expanded ? '收起' : ('展开剩余 ' + (maxLength - defaultLength) + ' 位')}}<img :class='{"expanded": expanded}' src="../../assets/imgs/collapse.png" /></div>
    <div class="expand-line"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      expanded: false,
    };
  },
  props: {
    maxLength: {
      type: Number,
      default: 3,
    },
    defaultLength: {
      type: Number,
      default: 3,
    },
  },
  methods: {
    collapse() {
      this.expanded = !this.expanded;
      this.$emit('expanded', this.expanded);
    },
  },
};
</script>

<style lang="less">
.collapse {
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 0 20px;
  width: 880px;
  margin: 0 auto;
  .expand-line {
    height: 0px;
    border-top: 1px solid #f0f0f0;
    width: 50%;
    margin: 0 10px 0 0;
  }
  .collapse-text {
    flex-shrink: 0;
  }
  .collapse-action {
    flex-shrink: 0;
    color: #5e9be1;
    margin-left: 5px;
    cursor: pointer;
    display: flex;
    align-items: center;
    & + .expand-line {
       margin: 0 0px 0 10px;
    }
    img {
      margin-left: 5px;
    }
    .expanded {
      transform: rotate(180deg);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/expand.vue